export const contactData = {
  phone: '790 277 277',
  email: 'kontakt@pethelp.pl',
  website: 'https://pethelp.pl/',
  insurance: 'https://pethelp.pl/oferta/ubezpieczenie/',
  clinics: 'https://pethelp.pl/plac%C3%B3wki/'
};

export const benefits = [
  'Kompleksowa opieka weterynaryjna dla psów i kotów, obejmująca badania, szczepienia, wizyty i wybrane zabiegi pielęgnacyjne.',
  'Niższy koszt profilaktyki niż zakup tych samych usług pojedynczo.',
  'Dostęp do ogólnopolskiej sieci placówek weterynaryjnych w dogodnych lokalizacjach.',
  'Przypomnienia o szczepieniach i badaniach oraz dostęp do karty medycznej online.',
  'Możliwość dokupienia ochrony na wypadek nagłych zachorowań i nieszczęśliwych wypadków pupila.'
];

export const serviceHighlights = {
  dog: [
    'Profilaktyczny przegląd zdrowia, wizyty chorobowe i kontrolne',
    'Badania krwi, moczu i kału oraz badanie kleszcza',
    'Szczepienia przeciw wściekliźnie, chorobom zakaźnym, kaszlowi kenelowemu i leptospirozie',
    'USG, RTG, konsultacja kardiologiczna i pomiar ciśnienia',
    'Czipowanie, usunięcie kleszcza, toaleta uszu, gruczołów okołoodbytowych i przycinanie pazurów',
    'Konsultacje online: dietetyczna i behawioralna'
  ],
  cat: [
    'Profilaktyczny przegląd zdrowia, wizyty chorobowe i kontrolne',
    'Badania krwi, moczu i kału oraz test FIV/FeLV',
    'Szczepienia przeciw chorobom zakaźnym, wściekliźnie i białaczce FeLV',
    'USG, RTG, konsultacja kardiologiczna i pomiar ciśnienia',
    'Czipowanie, usunięcie kleszcza, toaleta uszu i przycinanie pazurów',
    'Konsultacje online: dietetyczna i behawioralna'
  ]
};

export const dogPackages = [
  {
    category: 'Wizyty',
    items: [
      ['Profilaktyczny przegląd zdrowia', '1', '2', '3', '4'],
      ['Wizyta w przypadku choroby', '2', '4', '6', '10'],
      ['Wizyta kontrolna', '2', '4', '6', '10'],
      ['Konsultacja kardiologiczna (z echo serca)', '0', '0', '1', '1'],
      ['Konsultacja dietetyczna', '0', '0', '1', '1'],
      ['Konsultacja behawioralna', '0', '0', '1', '1']
    ]
  },
  {
    category: 'Badania laboratoryjne',
    items: [
      ['Badanie moczu podstawowe', '1', '1', '1', '1'],
      ['Badanie moczu ogólne', '0', '1', '1', '1'],
      ['Badanie krwi podstawowe', '1', '1', '1', '1'],
      ['Badanie krwi rozszerzone', '0', '1', '1', '1'],
      ['Badanie krwi profil tarczycowy', '0', '0', '1', '1'],
      ['Badanie krwi profil geriatryczny', '0', '0', '1', '1'],
      ['Badanie kału - flotacja', '1', '1', '1', '1'],
      ['Badanie kału - test Giardia', '0', '1', '1', '1'],
      ['Badanie kleszcza', '1', '2', '3', '4']
    ]
  },
  {
    category: 'Szczepienia i zabiegi',
    items: [
      ['Szczepienie przeciw wściekliźnie', '1', '1', '1', '1'],
      ['Szczepienie przeciw innym chorobom zakaźnym', '0', '1', '1', '1'],
      ['Szczepienie przeciw kaszlowi kenelowemu', '0', '1', '1', '1'],
      ['Szczepienie przeciw leptospirozie', '0', '0', '1', '1'],
      ['Obcinanie pazurów', '1', '2', '3', '6'],
      ['Toaleta uszu', '1', '2', '3', '6'],
      ['Toaleta gruczołów okołoodbytowych', '1', '2', '3', '6']
    ]
  },
  {
    category: 'Badania obrazowe i pozostałe usługi',
    items: [
      ['USG', '0', '1', '1', '2'],
      ['RTG', '0', '0', '1', '2'],
      ['Czipowanie', '1', '1', '1', '1'],
      ['Usunięcie kleszcza', '1', '2', '3', '4'],
      ['Roczny plan profilaktyczny', '1', '1', '1', '1'],
      ['Badanie ciśnienia krwi', '0', '1', '1', '1'],
      [
        'Dofinansowanie do preparatów przeciwpasożytniczych',
        '0 zł',
        '50 zł',
        '100 zł',
        '150 zł'
      ]
    ]
  }
];

export const catPackages = [
  {
    category: 'Wizyty',
    items: [
      ['Profilaktyczny przegląd zdrowia', '1', '2', '3', '4'],
      ['Wizyta w przypadku choroby', '2', '4', '6', '10'],
      ['Wizyta kontrolna', '2', '4', '6', '10'],
      ['Konsultacja kardiologiczna (z echo serca)', '0', '0', '1', '1'],
      ['Konsultacja dietetyczna', '0', '0', '1', '1'],
      ['Konsultacja behawioralna', '0', '0', '1', '1']
    ]
  },
  {
    category: 'Badania laboratoryjne',
    items: [
      ['Badanie moczu podstawowe', '1', '1', '1', '1'],
      ['Badanie moczu ogólne', '0', '1', '1', '1'],
      ['Badanie krwi podstawowe', '1', '1', '1', '1'],
      ['Badanie krwi rozszerzone', '0', '1', '1', '1'],
      ['Badanie krwi profil tarczycowy', '0', '0', '1', '1'],
      ['Badanie krwi profil geriatryczny', '0', '0', '1', '1'],
      ['Badanie kału - flotacja', '1', '1', '1', '1'],
      ['Badanie kału - test Giardia', '0', '1', '1', '1'],
      ['Test FIV/FeLV', '0', '1', '1', '1']
    ]
  },
  {
    category: 'Szczepienia i zabiegi',
    items: [
      ['Szczepienie przeciw wściekliźnie', '0', '1', '1', '1'],
      ['Szczepienie przeciw innym chorobom zakaźnym', '1', '1', '1', '1'],
      ['Szczepienie przeciw białaczce (FeLV)', '0', '0', '1', '1'],
      ['Obcinanie pazurów', '1', '2', '4', '6'],
      ['Toaleta uszu', '1', '2', '4', '6']
    ]
  },
  {
    category: 'Badania obrazowe i pozostałe usługi',
    items: [
      ['USG', '0', '1', '1', '2'],
      ['RTG', '0', '0', '1', '2'],
      ['Czipowanie', '1', '1', '1', '1'],
      ['Usunięcie kleszcza', '1', '2', '3', '4'],
      ['Roczny plan profilaktyczny', '1', '1', '1', '1'],
      ['Badanie ciśnienia krwi', '0', '1', '1', '1'],
      [
        'Dofinansowanie do preparatów przeciwpasożytniczych',
        '0 zł',
        '50 zł',
        '100 zł',
        '150 zł'
      ]
    ]
  }
];

export const activationSteps = [
  'Kliknij link aktywacyjny otrzymany od Pethelp i ustaw hasło do Panelu Klienta.',
  'W panelu przejdź do sekcji "Moje zwierzaki" i dodaj psa lub kota, uzupełniając wymagane pola.',
  'Po zapisaniu profilu zwierzaka możesz dodać także jego zdjęcie i uzupełnić pozostałe dane zdrowotne.',
  'Wejdź do zakładki "Moje bony", wybierz "Aktywuj", a następnie przypisz bon do zarejestrowanego zwierzaka.',
  'Podaj numer telefonu potrzebny do aktywacji pakietu i potwierdź operację.',
  'Po aktywacji korzystaj z panelu klienta do uzyskania zniżek/rabatów na produkty dla zwierząt, przeglądania zaleceń i realizacji konsultacji zdalnych.'
];

export const clinicFacts = [
  'Sieć obejmuje ponad 869 placówek w 377 miastach w Polsce według materiału Pethelp.',
  'Posiadacz pakietu może korzystać z dowolnej placówki dostępnej w aktualnej sieci Pethelp.',
  'Lista placówek jest aktualizowana na stronie Pethelp i regularnie rozszerzana o nowe lokalizacje.',
  'Jeśli na liście brakuje preferowanej lecznicy, Pethelp zachęca do zgłoszenia placówki do potencjalnej współpracy.'
];

export const pricing = {
  dog: [
    ['Standard', '52 zł'],
    ['Premium', '84 zł'],
    ['Platinum', '119 zł'],
    ['VIP', '170 zł']
  ],
  cat: [
    ['Standard', '42 zł'],
    ['Premium', '74 zł'],
    ['Platinum', '109 zł'],
    ['VIP', '160 zł']
  ]
};

export const packageLinks = {
  dog: {
    Standard: 'https://pethelp.pl/oferta/standard-dla-psa-tvp/',
    Premium: 'https://pethelp.pl/oferta/premium-dla-psa-tvp/',
    Platinum: 'https://pethelp.pl/oferta/platinum-dla-psa-tvp/',
    VIP: 'https://pethelp.pl/oferta/vip-dla-psa-tvp/'
  },
  cat: {
    Standard: 'https://pethelp.pl/oferta/standard-dla-kota-tvp/',
    Premium: 'https://pethelp.pl/oferta/premium-dla-kota-tvp/',
    Platinum: 'https://pethelp.pl/oferta/platinum-dla-kota-tvp/',
    VIP: 'https://pethelp.pl/oferta/vip-dla-kota-tvp/'
  }
};

export const packageHighlights = {
  dog: {
    Standard: {
      description:
        'Najprostszy sposób, żeby zapewnić psu spokojny start w opiece weterynaryjnej przez pełne 12 miesięcy.',
      bullets: [
        'Podstawowa profilaktyka i pierwsze wizyty: 1 przegląd zdrowia, 2 wizyty w przypadku choroby i 2 kontrolne.',
        'Najważniejsze badania na start: krew, mocz, kał oraz badanie kleszcza.',
        'Praktyczne elementy codziennej opieki: szczepienie przeciw wściekliźnie, czipowanie, pazury i uszy.'
      ]
    },
    Premium: {
      description:
        'Dobry wybór dla opiekuna, który chce mieć większy zapas wizyt i szerszą diagnostykę bez dopłacania za każdą usługę osobno.',
      bullets: [
        'Więcej komfortu przez cały rok: 2 przeglądy zdrowia, 4 wizyty chorobowe i 4 kontrolne.',
        'Szersza diagnostyka: mocz ogólny, krew rozszerzona, test Giardia, USG i pomiar ciśnienia.',
        'Dodatkowe szczepienia oraz 50 zł wsparcia na preparaty przeciwpasożytnicze.'
      ]
    },
    Platinum: {
      description:
        'Rozszerzony wariant dla psa, gdy zależy Ci już nie tylko na profilaktyce, ale też na szybszym dostępie do specjalistów.',
      bullets: [
        'Mocne zaplecze wizytowe: 3 przeglądy zdrowia, 6 wizyt chorobowych i 6 kontrolnych.',
        'Diagnostyka i specjaliści: USG, RTG, konsultacja kardiologiczna z echo serca, dietetyczna i behawioralna.',
        'Szczepienie przeciw leptospirozie oraz 100 zł wsparcia na preparaty przeciwpasożytnicze.'
      ]
    },
    VIP: {
      description:
        'Najpełniejszy pakiet dla psa, jeśli chcesz mieć maksymalny zakres opieki i najwyższe limity w jednym miejscu.',
      bullets: [
        'Najwyższy komfort przez cały rok: 4 przeglądy zdrowia, 10 wizyt chorobowych i 10 kontrolnych.',
        'Rozszerzona diagnostyka: 2 USG, 2 RTG i pełen pakiet konsultacji specjalistycznych.',
        'Najszerszy zakres usług pielęgnacyjnych oraz 150 zł wsparcia na preparaty przeciwpasożytnicze.'
      ]
    }
  },
  cat: {
    Standard: {
      description:
        'Pakiet startowy dla kota na 12 miesięcy, idealny gdy chcesz poukładać podstawową profilaktykę bez zbędnych formalności.',
      bullets: [
        'Podstawowa opieka przez cały rok: 1 przegląd zdrowia, 2 wizyty chorobowe i 2 kontrolne.',
        'Najważniejsze badania na start: krew, mocz i kał.',
        'Szczepienie przeciw chorobom zakaźnym, czipowanie, obcinanie pazurów i toaleta uszu.'
      ]
    },
    Premium: {
      description:
        'Rozszerzony pakiet dla kota z większą liczbą wizyt i diagnostyką, która daje więcej spokoju na co dzień.',
      bullets: [
        'Większy zapas opieki: 2 przeglądy zdrowia, 4 wizyty chorobowe i 4 kontrolne.',
        'Szersza diagnostyka: mocz ogólny, krew rozszerzona, test Giardia, test FIV/FeLV, USG i ciśnienie krwi.',
        'Szczepienie przeciw wściekliźnie oraz 50 zł wsparcia na preparaty przeciwpasożytnicze.'
      ]
    },
    Platinum: {
      description:
        'Pakiet dla opiekuna kota, który chce połączyć szeroką profilaktykę z dostępem do konsultacji specjalistycznych.',
      bullets: [
        'Mocny pakiet roczny: 3 przeglądy zdrowia, 6 wizyt chorobowych i 6 kontrolnych.',
        'USG, RTG, konsultacja kardiologiczna z echo serca, dietetyczna i behawioralna.',
        'Szczepienie przeciw białaczce FeLV oraz 100 zł wsparcia na preparaty przeciwpasożytnicze.'
      ]
    },
    VIP: {
      description:
        'Najszerszy pakiet dla kota, jeśli chcesz mieć maksymalny zakres opieki i najwyższe limity w jednym abonamencie.',
      bullets: [
        'Największy zapas wizyt: 4 przeglądy zdrowia, 10 wizyt chorobowych i 10 kontrolnych.',
        '2 USG, 2 RTG oraz pełen pakiet konsultacji specjalistycznych.',
        'Najszerszy zakres usług pielęgnacyjnych oraz 150 zł wsparcia na preparaty przeciwpasożytnicze.'
      ]
    }
  }
};
